// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bev_a bht_sl","StrollerBoxWidget__imageCounselling":"bev_b bht_jz"};